import React from "react"
import { css } from "@emotion/core"

import * as mixins from "../../../utils/mixins"

import ESCPlanningImg from "../imageComponents/optimized/planning"
import MethodsImg from "../imageComponents/optimized/home"
import HydroseedingImg from "../imageComponents/optimized/hydroseeding"
import InspectionsImg from "../imageComponents/optimized/inspections"

import {
  DisplayOptionContainer,
  DisplayImageCont,
  DisplayContentCont,
  DisplayContentBody,
  DisplayOptionLearnMore,
} from "../layoutComponents/display-container"

import {
  ESCPlanningTitle,
  MethodsTitle,
  HydroseedingTitle,
  InspectionsTitle,
} from "../../components/ourServices/titleBar"

export function ESCPlanningServiceContainer({ children }) {
  return (
    <ServicesDisplayOptionContainer>
      {children}
      <ServicesDisplayImageCont>
        <ESCPlanningImg />
      </ServicesDisplayImageCont>
      <ServicesDisplayContentCont>
        <ESCPlanningTitle
          containerStyles={css`
            display: none;

            ${mixins.device.tablet} {
              display: flex;
              justify-content: flex-start;
              background: none;
              box-shadow: none;
              padding: 0;
              margin-bottom: 0.5rem;
            }
          `}
          iconStyles={css`
            bottom: -0.25rem;
          `}
        />
        <ServicesDisplayContentBody>
          We make the right landscaping plan, taking into account your terrain,
          soil, native plants, and environmental conditions.
        </ServicesDisplayContentBody>
        <DisplayOptionLearnMore to="/site-planning/">
          EXPLORE SERVICE
        </DisplayOptionLearnMore>
      </ServicesDisplayContentCont>
    </ServicesDisplayOptionContainer>
  )
}

export function MethodsServiceContainer({ children }) {
  return (
    <ServicesDisplayOptionContainer>
      {children}
      <ServicesDisplayImageCont>
        <MethodsImg />
      </ServicesDisplayImageCont>

      <ServicesDisplayContentCont>
        <MethodsTitle
          containerStyles={css`
            display: none;

            ${mixins.device.tablet} {
              display: flex;
              justify-content: flex-start;
              background: none;
              box-shadow: none;
              padding: 0;
              margin-bottom: 0.5rem;
            }
          `}
          iconStyles={css`
            ${mixins.device.tablet} {
              bottom: -0.2rem;
              width: 115%;
            }
          `}
        />
        <ServicesDisplayContentBody>
          We save you time and money by using the latest equipment and
          cutting-edge technologies in the landscaping sector.
        </ServicesDisplayContentBody>
        <DisplayOptionLearnMore to="/landscaping/">
          EXPLORE SERVICE
        </DisplayOptionLearnMore>
      </ServicesDisplayContentCont>
    </ServicesDisplayOptionContainer>
  )
}

export function HydroseedingServiceContainer({ children }) {
  return (
    <ServicesDisplayOptionContainer>
      {children}
      <ServicesDisplayImageCont>
        <HydroseedingImg />
      </ServicesDisplayImageCont>

      <ServicesDisplayContentCont>
        <HydroseedingTitle
          containerStyles={css`
            display: none;

            ${mixins.device.tablet} {
              display: flex;
              justify-content: flex-start;
              background: none;
              box-shadow: none;
              padding: 0;
              margin-bottom: 0.5rem;
            }
          `}
          iconStyles={css`
            width: 115%;
            height: 115%;
            bottom: -0.15rem;
            position: absolute;
            margin-right: 1rem;
          `}
        />
        <ServicesDisplayContentBody>
          Protect your investment with our pro maintenance plans to keep your
          completed project looking great.
        </ServicesDisplayContentBody>
        <DisplayOptionLearnMore to="/maintenance/">
          EXPLORE SERVICE
        </DisplayOptionLearnMore>
      </ServicesDisplayContentCont>
    </ServicesDisplayOptionContainer>
  )
}

export function InspectionsServiceContainer({ children }) {
  return (
    <ServicesDisplayOptionContainer>
      {children}
      <ServicesDisplayImageCont>
        <InspectionsImg />
      </ServicesDisplayImageCont>

      <ServicesDisplayContentCont>
        <InspectionsTitle
          containerStyles={css`
            display: none;

            ${mixins.device.tablet} {
              display: flex;
              justify-content: flex-start;
              background: none;
              box-shadow: none;
              padding: 0;
              margin-bottom: 0.5rem;
            }
          `}
          iconStyles={css`
            position: absolute;
            bottom: -0.15rem;
          `}
        />
        <ServicesDisplayContentBody>
          Get guaranteed growth with our planting/vegetation service. We replant
          lawns, trees, and native shrubbery.
        </ServicesDisplayContentBody>
        <DisplayOptionLearnMore to="/revegetation/">
          EXPLORE SERVICE
        </DisplayOptionLearnMore>
      </ServicesDisplayContentCont>
    </ServicesDisplayOptionContainer>
  )
}

export function ReclamationServiceContainer({ children }) {
  return (
    <ServicesDisplayOptionContainer>
      {children}
      <ServicesDisplayImageCont>
        <ReclamationImg />
      </ServicesDisplayImageCont>

      <ServicesDisplayContentCont>
        <ReclamationTitle
          containerStyles={css`
            display: none;

            ${mixins.device.tablet} {
              display: flex;
              justify-content: flex-start;
              background: none;
              box-shadow: none;
              padding: 0;
              margin-bottom: 0.5rem;
            }
          `}
        />
        <ServicesDisplayContentBody>
          Guaranteed revegetation by tackling challenging soils, germination
          acceleration, site prep, seeding, and erosion prevention.
        </ServicesDisplayContentBody>
        <DisplayOptionLearnMore to="/revegetation/">
          EXPLORE SERVICE
        </DisplayOptionLearnMore>
      </ServicesDisplayContentCont>
    </ServicesDisplayOptionContainer>
  )
}

function ServicesDisplayOptionContainer({ children }) {
  return (
    <DisplayOptionContainer
      styles={css`
        ${mixins.device.tablet} {
          max-height: 12rem;
          margin-bottom: 1.75rem;
        }

        ${mixins.device.laptop} {
          max-height: 14rem;
        }
      `}
    >
      {children}
    </DisplayOptionContainer>
  )
}

function ServicesDisplayImageCont({ children }) {
  return (
    <DisplayImageCont
      styles={css`
        ${mixins.device.mobileL} {
          max-height: 16rem;
        }

        ${mixins.device.tablet} {
          max-height: inherit;
        }
      `}
    >
      {children}
    </DisplayImageCont>
  )
}

function ServicesDisplayContentCont({ children }) {
  return (
    <DisplayContentCont
      styles={css`
        ${mixins.device.laptop} {
          padding: 1rem 2rem 0;
        }
      `}
    >
      {children}
    </DisplayContentCont>
  )
}

function ServicesDisplayContentBody({ children }) {
  return (
    <DisplayContentBody
      styles={css`
        ${mixins.device.mobileM} {
          font-size: 1.1rem;
        }
        ${mixins.device.mobileX} {
          font-size: 1.2rem;
        }

        ${mixins.device.tablet} {
          font-size: 1.1rem;
        }

        ${mixins.device.laptop} {
          width: 95%;
          font-size: 1.2rem;
        }
      `}
    >
      {children}
    </DisplayContentBody>
  )
}
